export enum CERTIFICATION_DATE_STATUS {
  /**
   * 未生效
   */
  INEFFECTIVE = 0,
  /**
   * 已生效
   */
  EFFECTIVE = 1,
  /**
   * 已过期
   */
  OUTEFFECTIVE = 2
}
